import { ZONES } from "@/utils/horizonLayout";
import { useLanguage } from "@/contexts/LanguageContext";

const HorizonZoneBackground = () => {
  const { language } = useLanguage();

  return (
    <>
      {ZONES.map((zone) => (
        <div key={zone.key}>
          {/* Zone background - full width */}
          <div
            className="absolute left-0 right-0 rounded-lg"
            style={{
              bottom: `${zone.visualBottom * 100}%`,
              height: `${(zone.visualTop - zone.visualBottom) * 100}%`,
              backgroundColor: zone.color,
              opacity: 0.10,
            }}
          />

          {/* Zone label - inside the band, top-left */}
          <div
            className="absolute left-0 z-20 pointer-events-none"
            style={{
              top: `${(1 - zone.visualTop) * 100}%`,
              paddingTop: "8px",
              paddingLeft: "12px",
            }}
          >
            <span
              className="text-[9px] md:text-xs font-bold uppercase tracking-wider opacity-70"
              style={{ color: zone.color }}
            >
              {language === "fr" ? zone.labelFr : zone.labelEn}
            </span>
          </div>

          {/* Separator line at zone top */}
          <div
            className="absolute left-0 right-0 border-t pointer-events-none"
            style={{
              bottom: `${zone.visualTop * 100}%`,
              borderColor: "hsl(var(--border))",
            }}
          />
        </div>
      ))}
      {/* Bottom line */}
      <div
        className="absolute left-0 right-0 border-t pointer-events-none"
        style={{
          bottom: "0%",
          borderColor: "hsl(var(--border) / 0.3)",
          borderStyle: "dashed",
        }}
      />
    </>
  );
};

export default HorizonZoneBackground;
